import { loginReturnToKey } from './loginNavigation';

export const logoutPendingKey = 'selfservice.logoutPending';

const sessionKeys = [
  'AddContactAgencyCodes', 'agency_address', 'agency_code', 'agency_code_map',
  'agencyContacts', 'allAgencyCodes', 'bus_address', 'contactAdded',
  'contactTerminated', 'dataFetchProgress', 'edit_state', 'employeeId',
  'FilterContactType', 'FilterLocation', 'FilterSearchTerms', 'general_details',
  'incoming', 'intervalRef', 'isAdmin', 'isAgencyOpsInternalUser',
  'loggedInUserFirstName', 'loggedInUserLastName', 'loggedout', 'loggingout',
  'LoginIDInfo', 'loginType', 'mail_address', 'navigatedFrom', 'NewContact',
  'pageIndex', 'personId', 'personInfo', 'preferred_email',
  'primaryAgencyCodeSaveButton', 'privileges', 'redirect', 'redirectLocation',
  'res_address', 'selectedContactTypes', 'selectedContactTypesAll',
  'selectedEmail', 'selectedFirstName', 'selectedLastName', 'selectedLoginId',
  'selectedPersonId',
];

export function clearApplicationSession() {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('auth_') || sessionKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  });
  sessionStorage.removeItem('errorRedirectSource');
  sessionStorage.removeItem(loginReturnToKey);

  ['selfservice_cognitodomain', 'selfservice_clientid', 'selfservice_refreshtoken']
    .forEach(name => {
      // Older cookies were written without Path, so expire both known paths.
      ['/', '/logout'].forEach(path => {
        document.cookie = `${name}=; Max-Age=0; domain=.stateauto.com; path=${path}`;
      });
    });
}
